import Nav from "../components/Nav";
import EPSection from "../components/EPSection";
import FeaturedSingle from "../components/FeaturedSingle";
import About from "../components/About";
import OtherSongs from "../components/OtherSongs";
import YouTubeLatest from "../components/YouTubeLatest";
import Gallery from "../components/Gallery";
import Newsletter from "../components/Newsletter";
import SocialSection from "../components/SocialSection";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div
      data-testid="home-page"
      className="relative min-h-screen w-full overflow-x-hidden"
      style={{ background: "var(--yicel-bg)" }}
    >
      <Nav />
      <main>
        <EPSection />
        <FeaturedSingle />
        <About />
        <OtherSongs />
        <YouTubeLatest />
        <Gallery />
        <Newsletter />
        <SocialSection />
      </main>
      <Footer />
    </div>
  );
}
